"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValueMissing = exports.toFlowScope = exports.isInFlowScope = void 0;
const constants_1 = require("./constants");
function isInFlowScope(flowScope, flowScopeBit) {
    return (flowScope & flowScopeBit) > 0;
}
exports.isInFlowScope = isInFlowScope;
function toFlowScope(...flowScopeBits) {
    let flowScope = 0;
    flowScopeBits.forEach((bit) => {
        flowScope = flowScope | bit;
    });
    return flowScope;
}
exports.toFlowScope = toFlowScope;
function isValueMissing(value) {
    return value === undefined || value === null || value === constants_1.UNKNOWN_VALUE;
}
exports.isValueMissing = isValueMissing;
//# sourceMappingURL=liquitics-util.js.map